import type { ReactNode } from 'react'

import type { SchemaMapping, Size, Space, Variant } from '../../types'
import type { Props as BoxProps } from '../box/box'

type BaseIconProps = {
    size?: Size
    rotate?: number
    slot?: string
    tooltip?: string
} & Omit<BoxProps, 'as' | 'color'> & ({
    cornerIcons?: {
        topLeft?: ReactNode
        topRight?: ReactNode
        bottomLeft?: ReactNode
        bottomRight?: ReactNode
    }
    cornerIconSize?: number
    cornerIconBackgroundColor?: BoxProps['color']
    cornerIconBackgroundShape?: 'circle' | 'square' | 'none'
})

/*
 * PrivateIconProps are only used in the inner implementation
 * and are not available to the consumers.
 */
/** @public used in generated files */
export type PrivateIconProps = {
    viewBox?: string
}

type IconPropsWithVariant = {
    variant?: Variant | SchemaMapping | 'brand'
    color?: never
    keepFillColor?: false
} & BaseIconProps

type IconPropsWithColor = Pick<BoxProps, 'color'> & { variant?: never, keepFillColor?: false } & BaseIconProps

type IconPropsWithFillColor = { color?: never, variant?: never, keepFillColor: true } & BaseIconProps

/** @public used in generated files */
export type IconProps = IconPropsWithVariant | IconPropsWithColor | IconPropsWithFillColor
export type IconStaticProps = BaseIconProps

export const iconSizeMap: Record<Size, Space> = {
    'x-small': 'small',
    small: 'medium',
    medium: 'large',
    large: 'x-large',
    'x-large': 'xx-large',
}
